import { Box } from '@coolblue-development/becky';
import { Typography } from '@coolblue-development/freddy';
import EmailTransferIcon from '../../../Icons/EmailTransferIcon';

const TransferredBanner = (): JSX.Element => (
  <Box sx={{ margin: '16px 0', display: 'flex', justifyContent: 'center', gap: '8px' }}>
    <EmailTransferIcon />
    <Typography variant="h6" color="subtle">
      Transferred contact
    </Typography>
  </Box>
);

export default TransferredBanner;
